export const BODY = "body";
export const BURGER_BUTTON = "burgerButton";
export const COMPANY_SELECTOR_BUTTON = "companySelectorButton";
export const COMPANY_SELECTOR_BUTTON_MOBILE = "companySelectorButtonMobile";
export const COMPANY_SELECTOR_MENU = "companySelectorMenu";
export const CONTROLS_ITEM_FRAME_CLOSE_BUTTON = "controlsItemFrameCloseButton";
export const DESKTOP_DRAWER = "desktopDrawer";
export const DIALOG_CUSTOM_CLOSE_BUTTON = "dialogCustomCloseButton";
export const TASKS_LIST_CHOICE = "tasks";
